<template>
  <div
    class="site-width bespoke-footer-information"
    data-unit-test="bespoke-footer-information"
    @click.prevent="processLinkClick"
  >
    <div
      class="bespoke-footer-information__container ql-editor"
      data-unit-test="bespoke-footer-information__container"
      v-html="content"
    />
  </div>
</template>

<script>
export default {
  name: 'bespoke-footer-information',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  methods: {
    processLinkClick ({ target }) {
      if (target && target.tagName.toLowerCase() === 'a') {
        window.open(target.href, '_blank').focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bespoke-footer-information {
  $padding: 20px;

  width: 100%;
  margin: 0 auto;
  padding-top: $padding;
  padding-bottom: $padding;

  &__container {
    --padding: 15px;

    border-radius: 6px;
    background: #fff;
    border: 1px solid #e6eaee;
    padding: var(--padding, 25px);
    color: #a0a0a0;

    &::v-deep {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-weight: bold;
        line-height: 1.2;
        margin: 0;
        color: #000;
        padding: 0 0 1em;

        & + * { margin-top: 0.5em; }
      }

      h1 { font-size: 30px; }
      h2 { font-size: 26px; }
      h3 { font-size: 22px; }
      h4 { font-size: 18px; }
      h5 { font-size: 16px; }
      h6 { font-size: 14px; }

      p,
      & > div {
        margin: 0;

        & + * { margin-top: 0.5em; }
      }

      a {
        color: var(--v-primary-base, $clr-primary);
        text-decoration: underline;
      }

      ul {
        list-style: inside;
        margin: 0.5em 0;
        padding: 0 0 0 2em;
      }

      ol {
        list-style: numbered inside;
        margin: 0.5em 0;
        padding: 0 0 0 2em;
      }
    }
  }
}
</style>
